var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8504 12.0004C21.8504 17.3023 17.5523 21.6004 12.2504 21.6004C6.94846 21.6004 2.65039 17.3023 2.65039 12.0004C2.65039 6.69846 6.94846 2.40039 12.2504 2.40039C17.5523 2.40039 21.8504 6.69846 21.8504 12.0004ZM5.47412 11.9999C5.47412 8.25738 8.50806 5.22344 12.2506 5.22344C15.9931 5.22344 19.0271 8.25738 19.0271 11.9999C19.0271 15.7424 15.9931 18.7764 12.2506 18.7764C8.50806 18.7764 5.47412 15.7424 5.47412 11.9999ZM8.29765 11.9999C8.29765 14.1831 10.0674 15.9529 12.2506 15.9529C14.4337 15.9529 16.2035 14.1831 16.2035 11.9999C16.2035 9.81676 14.4337 8.04697 12.2506 8.04697C10.0674 8.04697 8.29765 9.81676 8.29765 11.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16C14.4591 16 16.25 14.2091 16.25 12C16.25 9.79086 14.4591 8 12.25 8C10.0409 8 8.25 9.79086 8.25 12C8.25 14.2091 10.0409 16 12.25 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2505 13.1289C12.8743 13.1289 13.3799 12.6233 13.3799 11.9995C13.3799 11.3758 12.8743 10.8701 12.2505 10.8701C11.6267 10.8701 11.1211 11.3758 11.1211 11.9995C11.1211 12.6233 11.6267 13.1289 12.2505 13.1289Z",
    fill: "#A62353"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8496,
    y: 19.2002,
    width: 4.8,
    height: 3.2,
    rx: 1.6,
    transform: "rotate(90 13.8496 19.2002)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8496,
    width: 4.8,
    height: 3.2,
    rx: 1.6,
    transform: "rotate(90 13.8496 0)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.0498,
    y: 13.5996,
    width: 4.8,
    height: 3.2,
    rx: 1.6,
    transform: "rotate(-180 5.0498 13.5996)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 13.5996,
    width: 4.8,
    height: 3.2,
    rx: 1.6,
    transform: "rotate(-180 24.25 13.5996)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics_icon.2cac485d44103e8abfbdc3036c59911e.svg";
export { ForwardRef as ReactComponent };